import { render, staticRenderFns } from "./OrgSettingsAccount.vue?vue&type=template&id=b3d84a22&scoped=true&"
import script from "./OrgSettingsAccount.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsAccount.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettingsAccount.vue?vue&type=style&index=0&id=b3d84a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d84a22",
  null
  
)

export default component.exports